module.exports = __webpack_public_path__ + "static/media/SEA-LAND.b10f820d.svg";